import { Injectable } from '@angular/core';

interface Script {
  name: string;
  src: string;
}

declare var document: any;

// This class allows us to load scripts dynamically via CDN and inject in the host
// This reduces bloat in the component for less frequently used visualizations and assets
@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private scripts: any = {};

  constructor() {}

  hasLoaded(name: string): boolean {
    return this.scripts[name] !== undefined;
  }

  load(script: Script): Promise<void> {
    return new Promise((resolve, reject) => {
      const loaded: boolean = this.scripts[script.name] && this.scripts[script.name].loaded;

      if (!loaded) {
        this.scripts[script.name] = {
          loaded: false,
          src: script.src
        };

        //load script
        let scriptRef = document.createElement('script');
        scriptRef.type = 'text/javascript';
        scriptRef.src = this.scripts[script.name].src;
        if (scriptRef.readyState) {
          //IE
          scriptRef.onreadystatechange = () => {
            if (scriptRef.readyState === 'loaded' || scriptRef.readyState === 'complete') {
              scriptRef.onreadystatechange = null;
              this.scripts[script.name].loaded = true;
              resolve();
            }
          };
        } else {
          //Others
          scriptRef.onload = () => {
            this.scripts[script.name].loaded = true;
            resolve();
          };
        }
        scriptRef.onerror = (error: any) => reject(error);
        document.getElementsByTagName('head')[0].appendChild(scriptRef);
      } else {
        resolve();
      }
    });
  }
}
